<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurredWhileLoadingServices"
  (click)="loadServices()"
>
</salonmonster-tap-retry>

<ng-container *ngIf="!isLoading && !errorOccurredWhileLoadingServices">
  <ion-row>
    <ion-col class="hidden-sm-down"></ion-col>

    <ion-col size="12" size-sm="12" size-md="8" size-lg="6" size-xl="6">
      <ion-card
        *ngIf="serviceCategoriesOffered.count() == 0"
        class="ion-text-center"
      >
        <ion-card-header>
          <h3>You currently don't have any services.</h3>
        </ion-card-header>
        <div class="ion-padding">
          <p>
            <span *ngIf="viewingMyServices"
              >Select one of the salon services below to add to your
              services</span
            >
            <span *ngIf="!viewingMyServices"
              >Select one of the salon services below to add to
              {{ stylist.getFirstName() + "'s" }} services</span
            >
            <br />
            or
          </p>

          <ion-button (click)="onAddAction()">
            Create a new service
          </ion-button>
        </div>
      </ion-card>

      <ion-card *ngIf="serviceCategoriesOffered.count() > 0">
        <ion-card-header>
          <ion-toolbar>
            <h3>
              {{
                viewingMyServices ? "Your" : stylist.getFirstName() + "'s"
              }}
              services
            </h3>
            <ion-button
              fill="clear"
              slot="end"
              icon-only
              (click)="onAddAction()"
            >
              <ion-icon name="add"></ion-icon>
            </ion-button>
          </ion-toolbar>
        </ion-card-header>

        <!-- <ion-card-content> -->
        <ion-list reorder="true" class="ion-padding">
          <ion-item-group
            *ngFor="
              let serviceCategory of serviceCategoriesOffered;
              let serviceCategoryIndex = index
            "
          >
            <ion-item-divider color="light">
              <ion-label class="category-label">{{
                serviceCategory.getCategoryName()
              }}</ion-label>
              <!-- <ion-icon slot="end" name="chevron-forward-outline"></ion-icon> -->
            </ion-item-divider>
            <!-- 
              <ion-item *ngIf="serviceCategory.getServiceDefinitions().count() == 0">
                <ion-note>No services</ion-note>
              </ion-item> -->

            <ion-item
              *ngFor="
                let serviceDefinition of serviceCategory.getServiceDefinitions();
                let serviceDefinitionIndex = index
              "
              (click)="onServiceDefinitionSelect(serviceDefinition, $event)"
              tappable
            >
              <ion-label>{{ serviceDefinition.name }}</ion-label>
              <!-- <ion-icon slot="end" name="chevron-forward-outline"></ion-icon> -->
              <!-- <ion-note item-right>{{ serviceDefinition.price | salonMonsterCurrency }}</ion-note> -->
              <!-- 
                <ion-button slot="end" fill="clear" icon-only (click)="onServiceDefinitionSelect(serviceDefinition, $event)">
                  <ion-icon name="create"></ion-icon>
                </ion-button> -->
            </ion-item>
          </ion-item-group>
        </ion-list>
        <!-- </ion-card-content> -->
      </ion-card>

      <br />

      <ion-card *ngIf="serviceCategoriesNotOffered.count() > 0">
        <ion-card-header>
          <h3 *ngIf="viewingMyServices">
            Salon services you don't currently offer.
          </h3>
          <h3 *ngIf="!viewingMyServices">
            Salon services not being offered by {{ stylist.getFirstName() }}
          </h3>
          <ion-note
            >Tap the "Add to
            {{
              viewingMyServices ? "your" : stylist.getFirstName() + "'s"
            }}
            services" button to add a salon service to your service offerings or
            create a new one.</ion-note
          >
        </ion-card-header>
        <ion-list class="ion-padding">
          <!-- <ion-list-header>Salon services you don't currently offer.</ion-list-header> -->
          <ion-item-group
            *ngFor="
              let serviceCategory of serviceCategoriesNotOffered;
              let serviceCategoryIndex = index
            "
          >
            <ion-item-divider color="light">
              <ion-label class="category-label">
                {{ serviceCategory.getCategoryName() }}
              </ion-label>
            </ion-item-divider>
            <!-- <sm-service-definition
              *ngFor="let serviceDefinition of serviceCategory.getServiceDefinitions(); let serviceDefinitionIndex = index;"
              [serviceDefinition]="serviceDefinition"
              tappable
              (click)="addSalonServiceToMyServices(serviceCategoryIndex, serviceDefinitionIndex, serviceDefinition, $event)"
            >
            </sm-service-definition> -->

            <ion-item
              *ngFor="
                let serviceDefinition of serviceCategory.getServiceDefinitions();
                let serviceDefinitionIndex = index
              "
            >
              <ion-label>{{ serviceDefinition.name }} </ion-label>
              <!-- <ion-note item-right>{{ serviceDefinition.price | salonMonsterCurrency }}</ion-note> -->

              <ion-button
                slot="end"
                fill="clear"
                (click)="addSalonServiceToMyServices(serviceDefinition, $event)"
              >
                <!-- <ion-icon name="add"></ion-icon> -->
                Add to
                {{
                  viewingMyServices ? "your" : stylist.getFirstName() + "'s"
                }}
                services
              </ion-button>
            </ion-item>
          </ion-item-group>
        </ion-list>
      </ion-card>
    </ion-col>

    <ion-col class="hidden-sm-down"></ion-col>
  </ion-row>
</ng-container>

<!-- <sm-service-definition-list
  *ngIf="!isLoading && !errorOccurredWhileLoadingServices && !errorOccurredWhileLoadingStylists"
  [serviceCategories]="serviceCategoriesOffered"
  (serviceCategorySelect)="onServiceCategorySelect($event)"
  (serviceDefinitionSelect)="onServiceDefinitionSelect($event)"
>
</sm-service-definition-list> -->
